import Vue from "vue";
import PageContainer from '@/components/PageContainer'
import PageInProgress from '@/components/PageInProgress'
import BaseVDataTable from "@/components/BaseVDataTable";

Vue.component('PageContainer', PageContainer);
Vue.component('PageInProgress', PageInProgress)
Vue.component('BaseVDataTable', BaseVDataTable)